module.exports = __webpack_public_path__ + "static/media/Icon awesome-redo-alt.057b9ea1.svg";